import { render } from "./StudioModal.vue?vue&type=template&id=9f452ac6"
import script from "./StudioModal.vue?vue&type=script&lang=js"
export * from "./StudioModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__